import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import {
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  FormControl,
  FormHelperText,
} from '@material-ui/core';
import messages from 'containers/PreOpeningPage/messages';
import { translate, arrayTranslate } from 'containers/services/translate';
import { CheckBoxWrapper } from 'containers/PreOpeningPage/OpposingParty/styled-components';
import { CheckCircle } from '@material-ui/icons';
import { CHOICE } from 'containers/PreOpeningPage/OpposingParty/constants';
import { get } from 'lodash';
import { displayErrorText } from 'containers/services/validateForm';

export type materialDammage = string | null;

export interface OpposingPartyCheckboxProps {
  intl: IntlShape;
  hasMaterialDammage: materialDammage;
  setHasMaterialDammage: React.Dispatch<React.SetStateAction<materialDammage>>;
  claimToPreopen: any;
  setClaimToPreopen: React.Dispatch<React.SetStateAction<any>>;
  opposingPartyValidation: any;
}

const OpposingPartyCheckbox: React.FC<OpposingPartyCheckboxProps> = ({
  hasMaterialDammage,
  setHasMaterialDammage,
  claimToPreopen,
  setClaimToPreopen,
  opposingPartyValidation,
  ...props
}): JSX.Element => {
  const translateArrayErrorMessages = arrayTranslate(props.intl.formatMessage);

  const { message } = displayErrorText(
    opposingPartyValidation,
    translateArrayErrorMessages(opposingPartyValidation, true),
  );
  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    setHasMaterialDammage(event.target.value);
    setClaimToPreopen(
      Object.assign(
        {},
        { ...claimToPreopen },
        {
          opposingParty: {
            hasMaterialDammage:
              event.target.value === CHOICE.YES
                ? event.target.value
                : CHOICE.NO,
            vehicules: [...claimToPreopen.opposingParty.vehicules],
          },
        },
      ),
    );
  };
  return (
    <CheckBoxWrapper>
      <Typography className="typography">
        {translate(messages.formQuestion, props)}
      </Typography>

      <FormControl>
        <RadioGroup row onChange={onChangeHandler} value={hasMaterialDammage}>
          <FormControlLabel
            control={
              <Radio
                color="primary"
                value={CHOICE.YES}
                checkedIcon={<CheckCircle />}
              />
            }
            label={translate(messages.yes, props)}
          />
          <FormControlLabel
            control={
              <Radio
                color="primary"
                value={CHOICE.NO}
                checkedIcon={<CheckCircle />}
              />
            }
            label={translate(messages.no, props)}
          />
        </RadioGroup>
        {!!get(opposingPartyValidation, 'hasMaterialDammage') && (
          <FormHelperText className="error">
            {message.hasMaterialDammage}
          </FormHelperText>
        )}
      </FormControl>
    </CheckBoxWrapper>
  );
};

export default injectIntl(OpposingPartyCheckbox);
